import React, { Component, Fragment } from 'react'


const discountBadge = (tour, dis_value) => {
    var bedge = dis_value > 0 ? "corner-ribbon top-left sticky red shadow" : ""
    var dis_type = tour.item_discount !== undefined && tour.item_discount.discount != undefined ? tour.item_discount[0].discount.dis_type : null

    if (dis_type == 0) {
        bedge = "corner-ribbon top-left sticky red shadow"
    } else if (dis_type == 1) {
        bedge = "corner-ribbon-login top-left sticky shadow"
    } else if (dis_type == 2) {
        bedge = "corner-ribbon-share top-left sticky shadow"
    }

    return bedge
};


function getCategoryName(tour) {
    var name = ""
    switch (tour.tour) {
        case "Day tour":
            name = tour.day_location.length > 0 ? tour.day_location[0].city.name : "Contact for more info"
            break;
        case "Round tour":
            name = tour.itinerary_category.name
            break;
        case "Maldive tour":
            name = tour.type_id == 1 ? 'Resort' : 'Package'
            break;
        case "Excursion":
            name = tour.location != null ? tour.location : ""
            break;

        default:
            break;
    }
    return name
}


function getTourDate(tour) {
    var dateBegin = new Date()
    var dateEnd = new Date()
    switch (tour.tour) {
        case "Day tour":
            dateBegin = new Date(tour.from_date)
            dateEnd = new Date(tour.to_date)
            break;
        case "Round tour":
            dateBegin = new Date(tour.from_price_date)
            dateEnd = new Date(tour.to_price_date)
            break;

        default:
            break;
    }
    return { dateBegin, dateEnd }
}

function getTitle(tour) {
    var title = ""
    switch (tour.tour) {
        case "Day tour":
            title = tour.title
            break;
        case "Round tour":
            title = tour.name
            break;
        case "Maldive tour":
            title = tour.title
            break;
        case "Excursion":
            title = tour.name != null ? tour.name : ""
            break;

        case "Rent Vehicle":
            title = tour.name != null ? tour.name : ""
            break;

        default:
            break;
    }

    title = title.length > 38 ? title.substring(0, 38) + "..." : title

    return title
}

function getPeragraphSpan(tour) {
    var label = ""

    switch (tour.tour) {
        case "Rent Vehicle":
            if (tour.vehicle_type != undefined) {
                label = tour.vehicle_type.type
            }
            break;
        default:
            break;
    }

    return label
}

function getPeragraph(tour) {
    var Pera = ""
    switch (tour.tour) {
        case "Day tour":
            Pera = tour.content

            break;
        case "Round tour":
            Pera = tour.description
            break;
        case "Maldive tour":
            Pera = tour.description
            break;
        case "Excursion":
            Pera = tour.description
            break;

        case "Rent Vehicle":
            if (tour.vehicle_type != undefined) {
                Pera = tour.vehicle_type.vehicle_description
            }

            break;
        default:
            break;
    }

    Pera = Pera != undefined && Pera.length > 100 ? Pera.substring(0, 100) + "..." : Pera

    return Pera
}



function getDiscValue(tour) {
    var value = 0
    if (tour.tour == "Day tour" || tour.tour == "Round tour") {
        if (tour.item_discount != undefined && tour.item_discount.length > 0 && tour.item_discount[0].discount != undefined) {
            value = tour.item_discount[0].discount.disc_value
        }
    } else if (tour.tour == "Maldive tour") {
        if (tour.tour_price.discount.length > 0) {
            value = tour.tour_price.discount.value
        }
    }


    return value
}


function getDiscountLable(tour) {
    var bedge = ""

    switch (tour.discount_type) {
        case 0:
            bedge = " OFF"
            break;
        case 1:
            if (tour.login) {
                bedge = <br /> + "LOGIN & GET"
            }
            break;
        case 2:
            bedge = <br /> + "SHARE & GET"
            break;

        default:
            break;
    }

    return bedge
}


class ThinRentListing extends Component {

    constructor(props) {
        super(props);
        var tour = this.props.tour
        this.state = {
            today: new Date(),
            fromDiscountDate: tour.item_discount != undefined && tour.item_discount.length > 0 && tour.item_discount[0].discount != undefined ? new Date(tour.item_discount[0].discount.from_discount_date) : new Date(),
            toDiscountDate: tour.item_discount != undefined && tour.item_discount.length > 0 && tour.item_discount[0].discount != undefined ? new Date(tour.item_discount[0].discount.to_discount_date) : new Date(),
            disc_value: getDiscValue(tour),

            dateBegin: getTourDate(tour).dateBegin,
            dateEnd: getTourDate(tour).dateEnd
        }
    }

    render() {
        var tour = this.props.tour
        return <Fragment>
            <div className="col-lg-3" data-aos="fade-up"
                data-aos-delay={(this.props.index % 4) * 150} data-aos-id={this.props.index}>
                <div className="card tc-item-update rout-tur trans-Rent fadeInUp">
                    <a href={this.props.url} >
                        <div className="tourbox" style={{ backgroundImage: `url(` + this.props.bgImage + `)` }}>
                            {getCategoryName(tour) != "" ?
                                <div className="touritemwrap-update">
                                    <div className="tourbox-bottom">
                                        <div className="tourbox-bottom-col1">{getCategoryName(tour)}</div>
                                    </div>
                                </div> : null}
                        </div>

                        <div className="cardinfo" >
                            <h4>{getTitle(tour)}</h4>
                            {getPeragraphSpan(tour) != "" ? <small>{getPeragraphSpan(tour)}</small> : null}
                            <div
                                dangerouslySetInnerHTML={{ __html: getPeragraph(tour) }}
                            />
                        </div>
                    </a>
                </div>
            </div>
        </Fragment>
    }
}


export default ThinRentListing;